import { ApiRequest } from '@zeal/zeal-lib';
import { NotificationsResponse } from '../../AppContainer/components/Notifications/types';
import { ENDPOINTS } from '../endpoints';

export async function listNotifications({
	queryKey: [, filters],
}: {
	queryKey: [string, { page: string } | undefined];
}) {
	return new ApiRequest(ENDPOINTS.notifications.list)
		.addHeader('Accept', 'application/json')
		.addQuery('page', filters?.page || '1')
		.GET<NotificationsResponse>();
}

export async function markAsRead(uuid: string) {
	return new ApiRequest(ENDPOINTS.notifications.markAsRead(uuid))
		.addHeader('Accept', 'application/json')
		.addHeader('Content-type', 'application/json')
		.POST('');
}

export async function markAllAsRead() {
	return new ApiRequest(ENDPOINTS.notifications.markAllAsRead)
		.addHeader('Accept', 'application/json')
		.addHeader('Content-type', 'application/json')
		.POST('');
}
